import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // ✅ important!
});

const authClient = axios.create({
  baseURL: AUTH_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // ✅ important!
});
// ✅ Automatically attach token for every request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const tempToken = localStorage.getItem("tempToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Use the regular token if available
    } else if (tempToken) {
      config.headers.Authorization = `Bearer ${tempToken}`; // Otherwise, use tempToken
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export { apiClient, authClient };



